// app/javascript/controllers/product_fill_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "description",
    "unit",
    "unitCode",
    "billingModel",
    "unitPrice",
    "vatRate",
    "percentageRate",
    "percentageRateDisplay"
  ]

  async load(event) {
    const id = event.target.value
    if (!id) return

    const response = await fetch(`/products/${id}/data`)
    const data = await response.json()

    this.descriptionTarget.value = data.description || ""

    if (this.hasUnitTarget) this.unitTarget.value = data.unit || ""
    if (this.hasUnitCodeTarget) this.unitCodeTarget.value = data.unit_code || ""
    if (this.hasBillingModelTarget) this.billingModelTarget.value = data.billing_model || ""
    if (this.hasVatRateTarget) this.vatRateTarget.value = data.vat_rate || 0
    if (this.hasUnitPriceTarget) this.unitPriceTarget.value = data.unit_price || 0

    const isPercentage = data.billing_model === "percentage" || data.billing_model === 4

    if (this.hasPercentageRateTarget) {
      this.percentageRateTarget.value = isPercentage ? (data.percentage_rate || 0) : 0
    }

    if (this.hasPercentageRateDisplayTarget) {
      this.percentageRateDisplayTarget.value = isPercentage ? `${data.percentage_rate || 0}%` : ""
    }

    this.element.dispatchEvent(new CustomEvent("product-filled", {
      bubbles: true,
      detail: { billingModel: data.billing_model }
    }))
  }
}